import * as React from "react";
import styled from "@mui/material/styles/styled";
import { useTranslate } from "../../hooks/useTranslate";
import { Theme } from "@mui/material";

//region [[ Styles ]]

const StrengthLinearView = styled("div")(({ theme }) => ({}));

const ProbabilityLabel = styled("div")(({ theme }) => ({}));

const ProbabilityNumber = styled("span")(({ theme }) => ({
  fontSize: "14px",
  color: "#243443",
}));

const ProbabilityDescription = styled("span")(({ theme }) => ({
  fontSize: "14px",
  color: "#939393",
}));

const ProgressBar = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "20px",
  marginBottom: "20px",
  borderRadius: "5px",
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
}));

const ProgressContainer = styled("div")(({ theme }) => ({
  width: "100%",
  position: "relative",
}));

const PROGRESS_BAR_HEIGHT = 4;

const ProgressBarBg = styled("div")(({ theme }) => ({
  backgroundColor: "#DADADA;",
  position: "absolute",
  width: "100%",

  borderRadius: "40px",
  height: PROGRESS_BAR_HEIGHT,
}));

const ProgressBarLine = styled("div")(
  ({ theme, value }: { theme?: Theme; value: string }) => ({
    backgroundColor: "#243443",
    width: value + "%",
    position: "absolute",
    borderRadius: "40px",
    height: PROGRESS_BAR_HEIGHT,
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]

export interface StrengthLinearProps {
  prob: number;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const StrengthLinear = ({ ...props }: StrengthLinearProps) => {
  const { translate } = useTranslate();

  return (
    <StrengthLinearView>
      <ProgressBar>
        <ProgressContainer>
          <ProgressBarBg></ProgressBarBg>
          <ProgressBarLine
            value={Math.round(props.prob).toString()}
          ></ProgressBarLine>
        </ProgressContainer>
      </ProgressBar>
      <ProbabilityLabel>
        <ProbabilityNumber>{`${Math.round(props.prob)}%`}</ProbabilityNumber>{" "}
        <ProbabilityDescription>
          {translate("PROBABILITY_DESCRIPTION")}
        </ProbabilityDescription>
      </ProbabilityLabel>
    </StrengthLinearView>
  );
};
